var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-list-container",attrs:{"id":"data-list-list-view"}},[(_vm.Privacys && _vm.Privacys.length)?_c('ol',_vm._l((_vm.Privacys),function(privacy,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(privacy.NameAR)+" ")])}),0):_c('p',[_vm._v("No data available")])])
}
var staticRenderFns = []

export { render, staticRenderFns }